import { hasAdvancedStats } from '@/utils/flashcards';

export default {
  computed: {
    showFlashcardMetadata() {
      return hasAdvancedStats(this.$store, this.$apptimize, this.$analytics);
    },
    difficultyLabel() {
      return this.flashcardMetadata?.difficultyLabel;
    },
    flashcardMetadata() {
      if (this.aliasOfFlashcard.userOwned) return null;
      return this.$store.getters['flashcardMetadata/flashcardMetadataByFlashcardId'](this.aliasOfFlashcard.id);
    },
    aliasOfFlashcard() {
      return this.flashcard || this.currentFlashcard || {};
    },
  },
  watch: {
    aliasOfFlashcard(newFlashcard) {
      this.fetchMetaData(newFlashcard);
    },
  },
  mounted() {
    this.fetchMetaData(this.aliasOfFlashcard);
  },
  methods: {
    answerPercentage(answerId) {
      const answer = this.flashcardMetadata?.answers?.find(a => a.answerId == answerId);
      return answer?.percentage || 0;

    },
    fetchMetaData(flashcard) {
      if (!flashcard?.id || flashcard.userOwned) return;
      const currentMetadata = this.$store.getters['flashcardMetadata/flashcardMetadataByFlashcardId'](flashcard.id);
      if (!currentMetadata) {
        this.$store.dispatch('flashcardMetadata/fetch', flashcard);
      }
    },
  },
};
